import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppHeaderService {
  private readonly titleSubject = new BehaviorSubject<string>('SoaTransfer');
  readonly title$ = this.titleSubject.asObservable();

  setTitle(title: string | null | undefined): void {
    const nextTitle = title?.trim() || 'SoaTransfer';
    this.titleSubject.next(nextTitle);
  }
}
